import React, { useEffect, useState, memo } from "react";
import HomePageCarousal from "./../components/HomePage/HomePageCarousal";
import SpotLight from "../components/Spotlight";
import Popover from "../components/Popover";

import { Box } from "@mui/material";
import { darkTheme, lightTheme } from "../theme/Theme";
import { useDispatch, useSelector } from "react-redux";
import ViewSummary from "../components/ViewSummary/ViewSummary";
import { getAPI } from "../API/ApiService";
import { BASE_URL } from "../constant/apiUrl";
import { setForumData } from "../slices/fritoForumPageSlice";

const Home = () => {
  const isDarkTheme = useSelector((state) => state.theme);
  const [slots, setSlots] = useState([]);
  const [spotlights, setSpotlights] = useState([]);
  const { viewSummaryDrawer } = useSelector((store) => store.viewSummary);

  const dispatch = useDispatch();
  const hasFetchedRef = React.useRef(false);
  
  useEffect(() => {
    // Prevent multiple calls
    if (hasFetchedRef.current) return;
    
    const fetchDashboardAggregate = async () => {
      hasFetchedRef.current = true;
      try {
        const response = await getAPI(`${BASE_URL}/aggregate/dashboard`);
        if (response?.status === 200) {
          const data = response.data;
          
          // Extract and set slots for the carousel
          if (data?.slots) {
            const sortedSlots = [...data.slots]
              .sort((a, b) => a.slotNumber - b.slotNumber)
              .filter((item) => item.isEnabled === true);
            setSlots(sortedSlots);
          }
          
          // Extract and set spotlights
          if (data?.spotlights) {
            setSpotlights(data.spotlights);
          }
          
          // Extract and set forums
          if (data?.forums) {
            dispatch(setForumData(data.forums));
          }
        }
      } catch (err) {
        console.log("Dashboard Aggregate Error:", err);
        hasFetchedRef.current = false; // Allow retry on error
      }
    };
    fetchDashboardAggregate();
  }, [dispatch]);

  return (
    <Box
      data-testid="home"
      sx={{
        background: isDarkTheme
          ? darkTheme.backgroundColorLayer1
          : lightTheme.backgroundColorLayer1,
      }}
    >
      <HomePageCarousal slots={ slots } data-testid="home-page-carousel" />
      <Box
        sx={{
          padding: { sm: "40px", xs: "40px 0px 0px" },
          marginTop: "50px",
          display: "flex",
          flexDirection: "column",
          gap: "24px",
        }}
      >
        <SpotLight pageData={spotlights} data-testid="spotlight" />

        <Popover data-testid="popover" />
      </Box>
      {viewSummaryDrawer && <ViewSummary data-testid="view-summary" />}
    </Box>
  );
};

export default memo(Home);
